// 登入後的「以公司帳號驗證」提示（kq Q143、審查 F14）：SSO 第一次登入回 no_account 的那個組織，員工自己登入 / 註冊並驗證 email 後，
// 在這裡直接走 mode = link。mode = link 只認已驗證的 email：begin 不擋、要到 exchange 才回 403 EMAIL_NOT_VERIFIED（平台審查 F2）
// → begin 前先看 session 的 email_verified，false 就先跳「先驗證你的 email」（寄信時才發現其實已驗證 → 直接繼續）。
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { KinioError } from '@kinio/web-sdk';
import { SessionError, session, ssoBegin, ssoDiscoverOrg, type SsoDiscovery } from '../../lib/session';
import { clearSsoLink, markSsoLinking, pendingSsoLinkOrg } from '../../lib/pendingSsoLink';
import { EmailVerifyPrompt, emailVerifyRequired } from '../../components/EmailVerifyPrompt';

export function SsoLinkPending() {
  const { t } = useTranslation();
  const [orgId, setOrgId] = useState(() => pendingSsoLinkOrg(session.get()?.user?.user_id));
  const [d, setD] = useState<SsoDiscovery | null>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [emailVerify, setEmailVerify] = useState<{ resend: boolean } | null>(null);

  useEffect(() => {
    if (orgId) void ssoDiscoverOrg(orgId).then(setD);
  }, [orgId]);

  async function go(checkEmail = true) {
    if (checkEmail && session.get()?.user?.email_verified === false) {
      setEmailVerify({ resend: true });
      return;
    }
    setBusy(true);
    setErr(null);
    try {
      const url = await ssoBegin(d!.org_id, 'link', '/');
      markSsoLinking();
      window.location.assign(url);
    } catch (x) {
      const ev = emailVerifyRequired(x);
      if (ev) setEmailVerify(ev);
      else {
        const c = x instanceof SessionError || x instanceof KinioError ? x.code : 'default';
        // begin mode=link 沒資格（不是成員、沒有寄到本人已驗證 email 的邀請、名冊對不上）→ 404：說清楚怎麼辦，提示不再留（審查 P2-1）
        if (c === 'NOT_FOUND') {
          setErr(t('sso.link_not_eligible'));
          clearSsoLink();
        } else setErr(t(`sso.err_${c}`, { defaultValue: t('sso.err_default', { code: c }) }));
      }
      setBusy(false);
    }
  }

  if (!orgId || !d) return null;
  return (
    <div className="notice card" data-testid="sso-link-pending">
      <strong>{d.org_display_name}</strong>
      {t('common.colon')}
      {t('sso.link_pending_body', { idp: d.idp_display_name })}{' '}
      <button type="button" className="btn btn-primary" disabled={busy} onClick={() => void go()} data-testid="sso-link-go">
        {t('scope.go_sso')}
      </button>{' '}
      <button
        type="button"
        className="btn"
        disabled={busy}
        onClick={() => {
          clearSsoLink();
          setOrgId(null);
        }}
      >
        {t('sso.link_pending_dismiss')}
      </button>
      {err && (
        <span className="error" role="alert">
          {' '}
          {err}
        </span>
      )}
      {emailVerify && <EmailVerifyPrompt resend={emailVerify.resend} onClose={() => setEmailVerify(null)} onVerified={() => void go(false)} />}
    </div>
  );
}
